import {Grid, Toolbar, Typography, Paper} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import {
  changeEnrollmentFileUploadFilters,
  clearClientOnboarding,
  clearSort,
  employerProfileUploadFiltersEmpty,
  getEmployerProfileUploadDetails,
} from 'Enrollment/ducks/enrollmentFileProcessing';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import './ClientOnboardingMaintenance.sass';
import {ModalState, showModal} from 'Core/ducks/modal';
import {Scope} from 'Shared/constants/Scope';
import UploadedEmployerProfileTable from './UploadedEmployerProfileTable';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';
import * as O from 'fp-ts/lib/Option';

export const hasAbilityToUploadEnrollmentApplications = (scopes: Scope[]) =>
  scopes.some(scope => /enrolltrack.employerprofile.upload/.test(scope));

const ClientOnboardingMaintenance = () => {
  const {employerProfileUploadDetails, employerProfileUploadFilters, sort} = useSelector(
    (state: ReducerState) => state.enrollmentFileProcessing
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployerProfileUploadDetails(undefined, employerProfileUploadFilters, O.toUndefined(sort)));
  }, [dispatch, employerProfileUploadFilters, sort]);

  useEffect(() => {
    return () => {
      dispatch(changeEnrollmentFileUploadFilters(employerProfileUploadFiltersEmpty));
      dispatch(clearSort());
      dispatch(clearClientOnboarding());
    };
  }, []);

  return (
    <div className="client-onboarding-files">
      <Toolbar className="client-onboarding-files-table">
        <Typography id="client-onboarding-files-title" className="client-onboarding-files-table__title" variant="h6">
          Bulk Profile Setup
        </Typography>
        <RequireAtLeastOneScope scopes={[Scope.EnrollTrackAdministrator, Scope.EmployerProfileUpload]}>
          <Tooltip title="Upload File">
            <IconButton
              id="client-onboarding-files-upload-file-button"
              className="btn-upload"
              onClick={() => dispatch(showModal(ModalState.ClientOnboardingUpload()))}
              aria-label="Upload File"
            >
              <PublishRoundedIcon />
            </IconButton>
          </Tooltip>
        </RequireAtLeastOneScope>
      </Toolbar>
      {employerProfileUploadDetails !== null ? (
        <UploadedEmployerProfileTable employerProfileData={employerProfileUploadDetails} />
      ) : (
        <Paper className="enrollment-file-dropzone">
          <Grid
            className="dropzone__enrollment__grid"
            container
            spacing={4}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} lg={5} md={6}>
              <div className="enrollment-file-dropzone__file-input">
                <div className="enrollment-file-dropzone__image" />

                <h3 className="enrollment-file-dropzone__title">No Uploaded Files</h3>

                <Typography className="enrollment-file-dropzone__content" variant="body2" color="initial">
                  No uploaded enrollment files. Click the "Upload File" button above to upload a new file.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Paper>
      )}
    </div>
  );
};

export default ClientOnboardingMaintenance;
